/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc ios绑定微信用户
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  iOSWechatDto: oauth2.IOSWechatDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/ios/wx-user/binding`,
    data: iOSWechatDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
